import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
export function CTASection() {
  return <section id="comprar" className="bg-white py-24 px-6 md:px-12 lg:px-24" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-10" data-id="element-20">
          <div className="space-y-4" data-id="element-21">
            <h2 className="text-4xl md:text-6xl font-bold text-navy" data-id="element-22">
              Empieza hoy con Checklist Vital
            </h2>
            <p className="text-2xl md:text-3xl text-gold font-semibold" data-id="element-23">
              Medicamentos y Citas Médicas
            </p>
          </div>

          <div className="py-8" data-id="element-24">
            <a href="https://www.plenavital.com/cart/48121424773345:1" className="inline-block w-full sm:w-auto bg-navy text-white text-2xl font-bold px-12 py-6 rounded-2xl hover:bg-navy/90 transition-all shadow-warm-lg hover:shadow-2xl transform hover:-translate-y-2 duration-300" data-id="element-25">
              Obtener Mi Checklist Ahora →
            </a>
            <p className="mt-4 text-lg text-navy/50 font-medium" data-id="element-26">
              Precio regular <span className="line-through" data-id="element-27">$18.99</span>
            </p>
            <p className="mt-2 text-xl text-navy/60 font-medium" data-id="element-28">
              Precio hoy: <span className="text-navy font-bold" data-id="element-29">$6.39</span>
            </p>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mt-16 bg-cream p-8 md:p-10 rounded-3xl border border-gold/20 text-left relative overflow-hidden" data-id="element-30">
            <HeartIcon className="absolute -right-4 -top-4 w-32 h-32 text-gold/5 rotate-12" data-id="element-31" />
            <h3 className="text-2xl font-bold text-navy mb-4 flex items-center gap-3" data-id="element-32">
              <span className="bg-gold text-white px-3 py-1 rounded-lg text-lg" data-id="element-33">
                P.D.
              </span>
              Para hijos y cuidadores
            </h3>
            <p className="text-xl text-navy/80 leading-relaxed mb-6 relative z-10" data-id="element-34">
              Este checklist también te ayuda a apoyar mejor a tus padres,
              porque todo queda escrito, claro y actualizado. Es la mejor manera
              de estar "en la misma página" sin discusiones.
            </p>
            <a href="#" className="text-xl font-bold text-gold hover:text-navy transition-colors inline-flex items-center gap-2 relative z-10" data-id="element-35">
              Consíguelo aquí para ellos →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}